var _excluded = ["description"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
/**
 * Formats a number with 0 or 1 decimal places based on if it's a percentage.
 * Also adds thousands separators for currency.
 * Example:
 * - For currency: "1000.00" -> "$1,000"
 * - For percentage: "10.35" -> "10.3"
 * @param num - The number to format.
 * @returns The formatted number.
 */
export var formatNumber = function formatNumber(_ref) {
  var number = _ref.number,
    isPercentage = _ref.isPercentage;
  var numberValue = typeof number === 'string' ? parseFloat(number) : number;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: isPercentage ? 1 : 0,
    // always add one decimal if it's a percentage
    minimumFractionDigits: isPercentage ? 1 : 0
  }).format(numberValue);
};

/**
 * Formats a date to a string.
 * Example: 2025-04-21T12:05:45.000-04:00 -> "April 21, 2025 UTC"
 * @param dateString - The date to format.
 * @returns The formatted date.
 */
export var formatDate = function formatDate(dateString) {
  var date = new Date(dateString);
  return "".concat(new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(date));
};

/**
 * Formats a single scholarship amount with the appropriate symbol
 * Example:
 * - For currency: "$1,000 USD"
 * - For percentage: "10% of tuition"
 */
export var formatAmount = function formatAmount(_ref2) {
  var amount = _ref2.amount,
    symbol = _ref2.symbol,
    isPercentage = _ref2.isPercentage;
  if (isPercentage) {
    return "".concat(formatNumber({
      number: amount,
      isPercentage: isPercentage
    })).concat(symbol);
  }
  return "".concat(symbol).concat(formatNumber({
    number: amount,
    isPercentage: isPercentage
  }));
};

/**
 * Gets the suffix text based on the amount type
 */
var getAmountSuffix = function getAmountSuffix(isPercentage, currencyCode) {
  return isPercentage ? 'of tuition' : currencyCode;
};

/**
 * Formats a scholarship amount range with appropriate currency or percentage formatting.
 * Example:
 * - For currency: "$1,000 - $2,000 USD"
 * - For percentage: "10% - 20% of tuition"
 */
export var formatScholarshipAmountRange = function formatScholarshipAmountRange(_ref3) {
  var amountFrom = _ref3.amountFrom,
    amountTo = _ref3.amountTo,
    currencySymbol = _ref3.currencySymbol,
    currencyCode = _ref3.currencyCode,
    amountType = _ref3.amountType;
  var isPercentage = amountType === 'percentage';
  var symbol = isPercentage ? '%' : currencySymbol;
  var formattedFrom = formatAmount({
    amount: amountFrom,
    symbol: symbol,
    isPercentage: isPercentage
  });
  var suffix = getAmountSuffix(isPercentage, currencyCode);
  if (!amountTo) {
    return "".concat(formattedFrom, " ").concat(suffix);
  }
  var formattedTo = formatAmount({
    amount: amountTo,
    symbol: symbol,
    isPercentage: isPercentage
  });
  return "".concat(formattedFrom, " - ").concat(formattedTo, " ").concat(suffix);
};

/**
 * Formats an external URL to include the protocol if it's missing
 * Example: "www.applyboard.com" -> "https://www.applyboard.com"
 */
export var formatExternalUrl = function formatExternalUrl(url) {
  if (!url) {
    return null;
  }
  return url.startsWith('http') ? url : "https://".concat(url);
};

/**
 * Removes the description from a scholarship
 * @param scholarship - The scholarship to remove the description from
 * @returns The scholarship without the description
 */
export var removeScholarshipDescription = function removeScholarshipDescription(scholarship) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _ = scholarship.description,
    rest = _objectWithoutProperties(scholarship, _excluded);
  return rest;
};

/**
 * Constants for the scholarship page
 */
export var consts = {
  // eslint-disable-next-line max-len
  autoAppliedTooltip: 'Auto-applied means that after you apply to a program offering this scholarship, if you meet the eligibility requirements, the scholarship is granted automatically (i.e. no separate scholarship application is needed). If a scholarship is not auto-applied, you must submit a separate scholarship application in addition to your program application.',
  allNationalitiesEligible: 'All nationalities',
  allProgramLevelsEligible: 'All program levels',
  noAdminNotes: 'No admin notes'
};